<template>
    <div>
        <div>
            <!-- Modal to choose withdrawal method ends -->
            <div class="modal fade" id="bank-options22">
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-top">
                    <p>Select bank.</p>
                    <span data-dismiss="modal" @click="withdrawalType = ''">X</span>
                  </div>
                  <p class="option-text">
                    Please select your preferred bank you want to make withdrawals to.
                  </p>
                  <hr />
                  <div class="modal-body text-center">
                    <div>
                      Bank list will come here
                    </div>

                    <div class="withdrawal-btn">
                      <button
                        @click="withdrawalType = ''"
                        type="button"
                        class="btn btn-block cancel"
                        data-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        class="btn btn-block continue"
                        @click="openOtp()"
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Modal to choose withdrawal method ends -->


            <div class="modal" tabindex="-1" id="bank-options">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title modal-top">Select bank</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <!-- <div class="form-group">
                                <label for="destination">Bank</label>
                                <select class="form-control" id="destination" v-model="bankinfo">
                                    <option value="" selected disabled>Select bank</option>
                                    <option v-for="(item, index) in banknameandcode" :key="index" :value="item">{{item.bank_name}}</option>
                                    
                                </select>
                            </div> -->

                            <div class="form-group">
                                <div class="dropdownn">
                                    <!-- Dropdown toggle -->
                                    <div class="dropdown-togglee" @click="toggleDropdown()">
                                    {{ selected || "Select bank" }}
                                    </div>

                                    <!-- Dropdown menu -->
                                    <div v-if="isOpen" class="dropdown-menuu">
                                    <!-- Search input -->
                                        <input
                                            name="search"
                                            type="text"
                                            v-model="search"
                                            placeholder="Filter by bank name"
                                            class="dropdown-search"
                                        />

                                        <!-- List of filtered items -->
                                        <ul class="dropdown-list">
                                            <li
                                            v-for="(item, index) in filteredItems"
                                            :key="index"
                                            @click="selectItem(item)"
                                            class="dropdown-item"
                                            >
                                            {{ item.bank_name }}
                                            </li>
                                            <li v-if="filteredItems.length === 0" class="no-results">
                                            No matches found
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="form-group">
                                <label for="bank">Bank name</label>
                                <input type="text" class="form-control" id="bank" placeholder="Bank name" v-model="bankname">
                            </div> -->
                            
                            <div class="form-group">
                                <label for="accountnumber">Account number</label>
                                <input type="text" class="form-control" id="accountnumber" placeholder="Account number" v-model="accountnumber">
                            </div>
                            <div class="form-group" v-if="accountname != ''">
                                <label for="acountname">Account name</label>
                                <input disabled type="text" class="form-control" id="accountname" placeholder="Account name" v-model="accountname">
                            </div>
                        </div>
                        <div class="modal-footer">
                            <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button> -->
                            <button :disabled="loadingaccount" v-if="!letsvalidate" type="button" class="btn primaryBtn" @click="validateAccountNumber()">
                                Verify Account
                                <span v-if="loadingaccount"><i class="fa fa-spinner fa-spin ml-3 f-12"></i></span>
                            </button>
                            <button type="button" v-if="letsvalidate" class="btn white-outline-btn" data-dismiss="modal" aria-label="Close" @click="afteraction()">
                                Cancel
                            </button>
                            <button :disabled="loadingaddAccount" type="button" v-if="letsvalidate" class="btn primaryBtn" @click="addAccountNumber()">
                                Add Account
                                <span v-if="loadingaddAccount"><i class="fa fa-spinner fa-spin ml-3 f-12"></i></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import realtor from "../services/realtor";

export default {
    name: "BankVerification",
    // props: {
    // },
    data() {
        return {
            loading: false,
            isOpen: false,
            loadingaccount: false,
            loadingaddAccount: false,
            letsvalidate: false,
            search: "",
            bankinfo: "",
            selected: "",
            accountnumber: "",
            accountname: "",

        }
    },
    computed: {
        filteredItems() {
        return this.banknameandcode.filter((item) =>
            item.bank_name.toLowerCase().includes(this.search.toLowerCase())
        );
      },
    },
    mounted() {
        this.fetchbankcodes();
    },
    methods: {
      openOtp() {
        $("#bank-options")
          .removeClass("fade")
          .modal("hide");
        $("#confirm-withdrawal")
          .addClass("fade")
          .modal("show");
      },
      toggleDropdown() {
          this.isOpen = !this.isOpen;
          this.search = "";
      },
      selectItem(item) {
          this.bankinfo = item;
          this.selected = item.bank_name;
          this.isOpen = false;
      },
      fetchbankcodes() {
        realtor.bankCodeList().then(data => {
            if (data.success) {
                this.banknameandcode = data.data;
            } else {
                this.$toast.error(data.error);
            }
        }).catch((err) => {
            console.log(err);
        //   this.$toast.error("please check your network and refresh the page");
        });
      },
      async validateAccountNumber() {
        if (this.accountnumber == '' || this.bankinfo.bank_code == '') {
            return this.$store.commit("setApiFailed", "Fill all required fields");
        }
        this.loadingaccount = true;
        const payload = {
          account_number: this.accountnumber,
          bank_code: this.bankinfo.bank_code
        }
        try {
            await realtor.validateBankAccount(JSON.stringify(payload))
            .then(res => {
                this.loadingaccount = false;
                if (res.success) {
                    res.bankName = this.bankinfo.bank_name
                    // this.accountname = res.data.accountName;
                    this.$emit('sendData', res)
                    // this.$store.commit("setApiSuccess", "Account vefiied");
                    this.letsvalidate = true;
                    $("#bank-options")
                      .removeClass("fade")
                      .modal("hide");
                    $("#confirm-withdrawal")
                      .addClass("fade")
                      .modal("show");
                }
                if (res.error){
                    this.$toast.error(res.error);

                }

                // this.$store.commit("setApiSuccess", "Success");
            })
            .catch(err => {
                this.loadingaccount = false;
                // console.log(err);
                this.$store.commit("setApiFailed", `An error occured:${err}`);
            });
        } finally {
            // console.log("Closed connection");
        }
      },
  }
}
</script>

<style scoped lang="scss">

.primaryBtn {
    background: #0033EA;
    font-family: Lato;
    font-weight: 600;
    font-size: 12px;
    color: #ffffff;
    outline: 0;
    box-shadow: none;
}

.form-group {
    label {
        font-family: Lato;
        font-weight: 500;
        font-size: 14px;
        line-height: 150%;
        color: #777777;
        text-align: left;
        display: flex;
    }
    input, select {
        border: 1px solid #BBBBBB;
        // color: #D1DBFF1A;
        height: 45px;
        color: #333333;
        font-family: Lato;
        font-weight: 600;
        font-size: 12px;
        box-shadow: none;
        outline: 0;
    }
}

.modal-header  {
    border-bottom: none;
}
.modal-footer {
    border-top: none;
}


// Filter starts here
.dropdownn {
  width: 100%;
  position: relative;
  font-family: Lato;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
}
.dropdown-togglee {
  padding: 10px;
  cursor: pointer;
  border: 1px solid #BBBBBB !important;
  border-radius: 4px solid !important;
  height: 48px !important;
  font-weight: 400 !important;
  color: 333333 !important;
  outline: 0 !important;
  box-shadow: none !important;
}
.dropdown-menuu {
  position: absolute;
  width: 100%;
  margin-top: 4px;
  border: 1px solid #ddd;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  font-family: Lato;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
}
.dropdown-search {
  width: 100%;
  padding: 8px;
  border: none;
  border-bottom: 1px solid #ddd;
  outline: none;
}
.dropdown-list {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 200px;
  overflow-y: auto;
}
.dropdown-item {
  padding: 10px;
  cursor: pointer;
  font-family: Lato;
  font-size: 12px;
  font-weight: 600;
}
.dropdown-item:hover {
  background: #f4f4f4;
}
.no-results {
  padding: 10px;
  color: #888;
  font-style: italic;
}
// Filter ends here


</style>